module.exports = __webpack_public_path__ + "static/img/11s.f064c30.png";


//////////////////
// WEBPACK FOOTER
// ./img/yj/11s.png
// module id = jWVD
// module chunks = 1